import { SupabaseClient } from '@supabase/supabase-js';
import React, { useState } from 'react';
import { RedirectTo } from '@habity/types/auth';
import { Link, Text, Button, Container, Input, Alert } from '@chakra-ui/react';
import { VIEWS } from '@habity/constants';
import { useTranslations } from 'next-intl';

function ForgottenPassword({
  setAuthView = () => null,
  supabaseClient,
  redirectTo,
  showLinks = false,
}: {
  setAuthView?: TODO;
  supabaseClient: SupabaseClient;
  redirectTo?: RedirectTo;
  showLinks?: boolean;
}) {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const t = useTranslations('Auth');

  const handlePasswordReset = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);
    const { error } = await supabaseClient.auth.resetPasswordForEmail(email, {
      redirectTo,
    });
    if (error) setError(error.message);
    else setMessage(t('forgotten_password.confirmation_text'));
    setLoading(false);
  };

  return (
    <form id="auth-forgot-password" onSubmit={handlePasswordReset}>
      <Container gap="large">
        <Container gap="large">
          <div>
            <Text>{t('forgotten_password.email_label')}</Text>
            <Input
              id="email"
              name="email"
              type="email"
              autoFocus
              placeholder={t('forgotten_password.email_input_placeholder')}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setEmail(e.target.value)
              }
            />
          </div>
          <Button type="submit" color="primary">
            {loading
              ? t('forgotten_password.loading_button_label')
              : t('forgotten_password.button_label')}
          </Button>
        </Container>
        {showLinks && (
          <Link
            href="#auth-sign-in"
            onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
              e.preventDefault();
              setAuthView(VIEWS.SIGN_IN);
            }}
          >
            {t('sign_in.link_text')}
          </Link>
        )}
        {message && <Alert>{message}</Alert>}
        {error && <Alert status="error">{error}</Alert>}
      </Container>
    </form>
  );
}

export { ForgottenPassword };
